"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWithTooltip = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
const Icon_1 = __importDefault(require("../Icon/Icon"));
const Tooltip_1 = require("./Tooltip");
const IconWithTooltip = (props) => {
    const [visible, setVisible] = react_1.useState(false);
    const boundaryRef = react_1.useRef(null);
    const handleTouchOutside = (event) => {
        if (boundaryRef.current && !boundaryRef.current.contains(event.target)) {
            setVisible(false);
        }
    };
    const handleIconMouseEvents = () => {
        if (visible) {
            setVisible(false);
        }
        else {
            setVisible(true);
        }
    };
    const handleCloseButton = () => {
        setVisible(false);
    };
    react_1.useEffect(() => {
        document.addEventListener('click', handleTouchOutside, false);
        return () => {
            document.removeEventListener('click', handleTouchOutside, false);
        };
    }, []);
    const iconInner = classnames_1.default({
        'icon-with-label-has-tooltip': true,
        'icon-with-label-inner': true,
        'icon-with-label-xs': props.size === 'xs',
        [`form-icon`]: props.form ? props.form : false,
        [props.className]: !!props.className,
    });
    const iconOuter = classnames_1.default({
        'icon-tooltip-outer': !props.label,
        'icon-with-label-outer': props.label,
        [`tooltip-icon-form`]: props.form ? props.form : false,
    });
    return (React.createElement("div", { ref: boundaryRef, className: iconOuter },
        React.createElement("div", { className: iconInner },
            React.createElement("div", { onClick: handleIconMouseEvents },
                React.createElement(Icon_1.default, { icon: props.icon })),
            visible && (React.createElement(Tooltip_1.Tooltip, { text: props.text, position: props.position, handleClose: handleCloseButton }))),
        props.label && React.createElement("div", null, props.label)));
};
exports.IconWithTooltip = IconWithTooltip;
//# sourceMappingURL=IconWithTooltip.js.map